// extracted by mini-css-extract-plugin
export var diagrams = "floor-plan-promo-module--diagrams--L66Rn";
export var firstFloor = "floor-plan-promo-module--first-floor--zkniQ";
export var floorPlan = "floor-plan-promo-module--floor-plan--xzzny";
export var groundFloor = "floor-plan-promo-module--ground-floor--9sDC8";